import { Box } from '@jotta/ui/Box'
import { Input } from '@jotta/ui/Input'
import { Label } from '@jotta/ui/Label'
import { t } from '@lingui/macro'
import type { ChangeEvent, FC, FormEvent } from 'react'
import { useState } from 'react'
import { PasswordInput } from '../../Forms/PasswordInput/PasswordInput'
import type { RadixDialogProps } from '../RadixDialog/RadixDialog'
import { RadixDialog } from '../RadixDialog/RadixDialog'

export interface VerifyPasswordDialogProps extends RadixDialogProps {
  destructive?: boolean
  /** Label text for verify button */
  verifyButtonText?: string
  /** Label text for cancel button */
  cancelButtonText?: string
  /** Verify button loading state  */
  isLoading?: boolean
  /** Verification handler  */
  onVerify: (password: string) => void
  /** Username field, will be used for browser to suggest correct user's password for password field  */
  forUser?: string
}
export const VerifyPasswordDialog: FC<VerifyPasswordDialogProps> = ({
  title = t({ id: 'Authentication Required' }),
  destructive,
  verifyButtonText = t`Verify`,
  cancelButtonText = t`Cancel`,
  isLoading,
  onClose,
  onVerify,
  forUser,
  ...props
}) => {
  const [password, setPassword] = useState('')
  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    setPassword(e.target.value)
  }
  const onSubmit = (e: FormEvent) => {
    e.preventDefault()
    onVerify(password)
  }
  return (
    <RadixDialog
      title={title}
      onClose={onClose}
      buttons={[
        {
          action: 'close',
          label: cancelButtonText,
          type: 'outline',
        },
        {
          disabled: password.length <= 0,
          label: verifyButtonText,
          loading: isLoading,
          type: destructive ? 'destructive' : 'primary',
          action: onSubmit,
        },
      ]}
      {...props}
    >
      <Box as="form" onSubmit={onSubmit} sx={{ py: 2 }}>
        {forUser && (
          <Label label={t`Email`}>
            <Input
              name="email"
              id="email"
              type="email"
              defaultValue={forUser}
              autoComplete="email"
              disabled
            />
          </Label>
        )}
        <Label label={t`Type in your password to proceed`}>
          <PasswordInput
            name="password"
            id="password"
            autoComplete="current-password"
            autoFocus
            value={password}
            onChange={onChange}
          />
        </Label>
        <button type="submit" sx={{ display: 'none' }} />
      </Box>
    </RadixDialog>
  )
}
